import Validator from './validator.js';

export default class MandatoryRadioValidator extends Validator {
    constructor(input) {
        super(input);
        this.field = input.parent;
        this.name = input.el.name;
        this.radios = [...this.field.el.querySelectorAll(`[name="${this.name}"]`)];
    }

    valid() {
        return Promise.resolve(this.radios.some((el) => el.checked));
    }

    static applies(input) {
        return input.el.dataset.mandatoryRadio !== undefined;
    }
}
